import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import TeamFormWizard from './TeamFormWizard';
import { API_URL } from '../../api/api';

const auth = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

// Wrapper route at /:role/teams/:id/edit. Loads the employee, then renders
// the existing wizard in admin mode. Closing the wizard returns to the
// profile page (or list as fallback).
export default function EmployeeEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const role = (localStorage.getItem('role') || 'admin').toLowerCase();
  const base =
    role === 'hr' ? '/hr' : role === 'member' ? '/member' : '/admin';

  const [member, setMember] = useState(null);
  const [error, setError] = useState(null);

  // A member may only edit their OWN profile. If they try to reach someone
  // else's edit URL, bounce them back to that person's read-only profile.
  const ownMemberId = (() => {
    try {
      return JSON.parse(localStorage.getItem('userdata') || '{}').member_id || null;
    } catch {
      return null;
    }
  })();
  const blockedSelfEdit =
    role === 'member' && ownMemberId != null && String(ownMemberId) !== String(id);

  useEffect(() => {
    if (blockedSelfEdit) {
      navigate(`${base}/teams/${id}`, { replace: true });
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API_URL}/api/team/${id}`, auth());
        if (!cancelled) setMember(res.data);
      } catch (err) {
        if (err?.response?.status === 401) {
          localStorage.clear();
          window.location.assign('/login');
          return;
        }
        if (!cancelled) {
          setError(err?.response?.data?.error || 'Could not load employee');
        }
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, blockedSelfEdit]);

  const handleClose = () => navigate(`${base}/teams/${id}`);
  const handleSaved = () => navigate(`${base}/teams/${id}`);

  if (error) {
    return (
      <div className="management-section employee-wrap">
        <p style={{ padding: 24, color: '#dc2626' }}>⚠ {error}</p>
      </div>
    );
  }
  if (!member) {
    return (
      <div className="management-section employee-wrap">
        <p style={{ padding: 24 }}>Loading…</p>
      </div>
    );
  }

  return (
    <div className="management-section employee-wrap">
      <TeamFormWizard
        editData={member}
        mode="admin"
        onClose={handleClose}
        onSaved={handleSaved}
      />
    </div>
  );
}
